import { render } from "./Sensor.vue?vue&type=template&id=9d873f86"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__